import React from "react";
import useForm from "../hooks/useForm";
import { Timestamp } from "firebase/firestore";
import { REGIONS_API } from "../constants/api";
import { FormWrapper } from "../components/styled/StyledComponents";
import { GenericInput } from "../components/input/GenericInput";
import { sActive, sAddRegion, sUGX, sUpdate } from "../constants/strings";
import { useFirebase } from "../hooks/firebase/useFirebase";
import { Stack } from "@mui/material";
import { GenericSwitch } from "../components/elements/Switch";
import { FormButton } from "../components/buttons/FormButton";
import { AutofillForm } from "../utils/helpers";

export const RegionForm = ({ data, setOpen }) => {
  const { form, onChange, updateFormValue, updateFormValues, setForm } =
    useForm({
      active: true,
    });
  const { loading, addData: addRegion, updateData } = useFirebase();

  const onSubmit = (e) => {
    e.preventDefault();
    if (data) {
      // update region
      updateData(data.docRef, form).then(() => setOpen(false));
    } else {
      // add region
      form.timestamp = Timestamp.now();
      addRegion(
        REGIONS_API,
        form,
        updateFormValues({
          region_name: "",
          cost: "",
        })
      );
    }
  };

  AutofillForm(data, setForm);

  return (
    <form onSubmit={onSubmit}>
      <FormWrapper>
        <Stack spacing={3}>
          {/* Name */}
          <GenericInput
            label="Region Name"
            required
            value={form.region_name}
            name="region_name"
            onChange={onChange}
          />
          {/* Cost */}
          <GenericInput
            label="Cost"
            onChange={onChange}
            name="cost"
            suffix={sUGX}
            value={form.cost}
            type="number"
            required
          />

          {/* Switch */}
          <GenericSwitch label={sActive} updateFormValue={updateFormValue} />

          {/* Submit */}
          <FormButton loading={loading}>
            {data ? sUpdate : sAddRegion}
          </FormButton>
        </Stack>
      </FormWrapper>
    </form>
  );
};
